import React from 'react';
import '../../../scss/ordo/background-overlay.scss';

type BackgroundOverlayProps = { onClick: () => void };

export const BackgroundOverlay = ({onClick}:BackgroundOverlayProps) =>
  <div className="overlay" role="presentation" onClick={onClick}/>;

